import ROUTES from "../router/routesModel";

/**
 * Bottom nav IA (trade-first):
 * Collection · Map · TRADES (hero) · Wishlist · Chat
 * — Market catalog and Profile are NOT bottom tabs (Cards: /pokemontcg via Map
 *   chip or account sheet; Profile: top account control → ProfileAccountSheet).
 *
 * A nav badge means ACTION NEEDED, never inventory size. Collection and Wishlist
 * previously badged their own item counts, so both tabs wore a permanent number
 * that never asked for anything — which taught users to ignore the one badge
 * that does (unread chat). Counts still belong on the pages themselves.
 */
export const BOTTOM_NAV_ITEMS = [
  { id: "collection", label: "Collection", route: ROUTES.COLLECTION },
  { id: "map", label: "Map", route: ROUTES.MAP },
  { id: "trades", label: "Trades", route: ROUTES.TRADES, hero: true },
  { id: "wishlist", label: "Wishlist", route: ROUTES.WISHLIST },
  { id: "chat", label: "Chat", route: ROUTES.CHAT, badge: "chat" },
];

/** Routes that must stay reachable even if removed from the bottom bar. */
export const DISCOVERABLE_ROUTES = {
  market: ROUTES.POKEMON_CARDS,
  profileBase: ROUTES.PROFILE,
  trades: ROUTES.TRADES,
};

export function getBottomNavLabels() {
  return BOTTOM_NAV_ITEMS.map((i) => i.label);
}

export function isBottomNavRoute(pathname, route) {
  if (!route) return false;
  if (route === ROUTES.ROOT) return pathname === ROUTES.ROOT;
  return pathname === route || pathname.startsWith(`${route}/`);
}

export function resolveActiveBottomNavId(pathname) {
  const match = BOTTOM_NAV_ITEMS.find((item) => isBottomNavRoute(pathname, item.route));
  return match?.id || null;
}

/** Hero tab must be exactly one item and sit in the center of an odd-length bar. */
export function assertTradeFirstNav(items = BOTTOM_NAV_ITEMS) {
  const heroes = items.filter((i) => i.hero);
  const mid = Math.floor(items.length / 2);
  return {
    ok:
      items.length === 5 &&
      heroes.length === 1 &&
      heroes[0].id === "trades" &&
      items[mid].id === "trades" &&
      !items.some((i) => i.id === "market" || i.id === "profile"),
    heroes: heroes.map((h) => h.id),
    centerId: items[mid]?.id,
  };
}
